import { render, staticRenderFns } from "./ActionIngresarABodega.vue?vue&type=template&id=4bae9f9d&lang=pug"
import script from "./ActionIngresarABodega.vue?vue&type=script&lang=js"
export * from "./ActionIngresarABodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports